module.exports = __webpack_public_path__ + "static/img/home-screen-phone.f9b0dd7d.png";